<template>
  <div class="w-full">
    <component
      :is="answerComponent"
      :question="question"
      :survey-id="surveyId"
      :editable="editable"
      :density="density"
      :value="value"
      @change="(data) => emits('change', data)"
    />
  </div>
</template>

<script lang="ts" setup>
import {QuestionType, SurveyQuestion} from "@/core/interfaces/survey/Survey";
import SurveyBuiltChoices from "@/survey/components/SurveyBuiltChoices.vue";
import SurveyBuiltMultipleChoices from "@/survey/components/SurveyBuiltMultipleChoices.vue";
import SurveyBuiltInput from "@/survey/components/SurveyBuiltInput.vue";
import SurveyBuiltDate from "@/survey/components/SurveyBuiltDate.vue";
import {computed} from "vue";

const emits = defineEmits<{
    (e: 'change', answer: unknown): void;
}>();

const {question, density = 'normal', editable = false} = defineProps<{
    surveyId: number;
    question: SurveyQuestion;
    editable?: boolean;
    value?: (string | number | boolean | undefined)[] | null | Record<string, unknown>;
    density?: 'compact' | 'normal';
}>();

const componentMap = {
    [QuestionType.YES_NO]: SurveyBuiltChoices,
    [QuestionType.SINGLE_CHOICE]: SurveyBuiltChoices,
    [QuestionType.MULTIPLE_CHOICE]: SurveyBuiltMultipleChoices,
    [QuestionType.TEXT_INPUT]: SurveyBuiltInput,
    [QuestionType.CHECK_INPUT]: SurveyBuiltInput,
    [QuestionType.DATE]: SurveyBuiltDate,
};

const answerComponent = computed(() => {
    return componentMap[question.type.slug] || SurveyBuiltChoices;
});
</script>
